import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const RnMDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="R & M"
      sectionId="rnm"
      sectionKey="R & M"
      description="Repair & Maintenance Operations"
      backRoute="/"
    />
  );
};

export default RnMDashboard;
